import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import InfoIcon from "./../../assets/images/icons/info.png";

interface PdfPasswordExampleRow {
  primaryApplicantName: string;
  dateOfBirth: string;
  password: string;
}

interface PdfPasswordInfoProps {
  /** Optional override for the example rows shown in the table. */
  exampleRows?: PdfPasswordExampleRow[];
}

const DEFAULT_EXAMPLE_ROWS: PdfPasswordExampleRow[] = [
  {
    primaryApplicantName: "Suresh Gandhi",
    dateOfBirth: "17th October, 1996",
    password: "sure17101996",
  },
  {
    primaryApplicantName: "G. P. Rao",
    dateOfBirth: "10th January, 1995",
    password: "gpra10011995",
  },
  {
    primaryApplicantName: "M K Associates",
    dateOfBirth: "5th May, 2009",
    password: "mkas05052009",
  },
];

/**
 * Info block explaining the password-protection rule for downloaded PDFs,
 * followed by an example table. Shared across statement/document screens
 * (Statement.tsx, DocumentTerm.tsx) so the wording and styling stay in sync.
 */
const PdfPasswordInfo: React.FC<PdfPasswordInfoProps> = ({
  exampleRows = DEFAULT_EXAMPLE_ROWS,
}) => {
  return (
    <Box sx={{ mt: 1 }}>
      <Typography
        className="statement-info"
        sx={{ display: "flex", alignItems: "flex-start", fontSize: "12px" }}
      >
        <img
          src={InfoIcon}
          alt="Info Icon"
          style={{ marginRight: "5px", marginTop: "2px", cursor: "pointer" }}
        />
        <span>
          PDF will be password protected, Password will be the first 4 letters
          of the Primary Applicant&apos;s name in small letters (without spaces
          or dots), followed by the Date of Birth / Date of Incorporation in
          DDMMYYYY format.
        </span>
      </Typography>

      <Typography sx={{ fontSize: "13px", fontWeight: 600, mt: 1.5, mb: 0.5 }}>
        Example:
      </Typography>

      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          boxShadow: "none",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Table
          size="small"
          aria-label="PDF password example"
          sx={{
            backgroundColor: "#f5f5f5",
            "& td, & th": {
              border: "1px solid #d0d0d0",
            },
          }}
        >
          <TableHead 
            sx={{
              backgroundColor: "#f8f8f8",
            }}
          >
            <TableRow>
              <TableCell sx={{ fontWeight: 600, fontSize: "12px" }}>
                Primary Applicant Name
              </TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: "12px" }}>
                Date of Birth / Date of Incorporation
              </TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: "12px" }}>
                Password
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {exampleRows.map((row, idx) => (
              <TableRow key={`${row.password}-${idx}`}>
                <TableCell sx={{ fontSize: "12px" }}>
                  {row.primaryApplicantName}
                </TableCell>
                <TableCell sx={{ fontSize: "12px" }}>
                  {row.dateOfBirth}
                </TableCell>
                <TableCell sx={{ fontSize: "12px",fontWeight:"bold" }}>{row.password}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PdfPasswordInfo;
